import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./slices/counter";
import sidebarMenuReducer from "./slices/sidebarMenu";
import roleReducer from "./slices/role";
import snackbarReducer from "./slices/snackbar";
import websocketReducer from "./slices/websocket";
import notificationsReducer from "./slices/notifications";
import visureAiAnalysisReducer from "./slices/visureAiAnalysis";
import rcAutoFiltersReducer from "./slices/rcAutoFilters";
import richiesteFiltersReducer from "./slices/richiesteFilters";
import richiestePaginationReducer from "./slices/richiestePagination";
import rcAutoPaginationReducer from "./slices/rcAutoPagination";
import issueFiltersReducer from "./slices/issueFilters";
import accordiFiltersReducer from "./slices/accordiFilters";
import usersFiltersReducer from "./slices/usersFilters";
import dynamicGridFiltersReducer from "./slices/dynamicGridFilters";
import libriMatricolaFiltersReducer from "./slices/libriMatricolaFilters";
import visureFiltersReducer from "./slices/visureFilters";
import websocketMiddleware from "./middlewares/websocket";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    sidebarMenu: sidebarMenuReducer,
    role: roleReducer,
    websocket: websocketReducer,
    snackbar: snackbarReducer,
    notifications: notificationsReducer,
    visureAiAnalysis: visureAiAnalysisReducer,
    rcAutoFilters: rcAutoFiltersReducer,
    richiesteFilters: richiesteFiltersReducer,
    richiestePagination: richiestePaginationReducer,
    rcAutoPagination: rcAutoPaginationReducer,
    issueFilters: issueFiltersReducer,
    accordiFilters: accordiFiltersReducer,
    usersFilters: usersFiltersReducer,
    dynamicGridFilters: dynamicGridFiltersReducer,
    libriMatricolaFilters: libriMatricolaFiltersReducer,
    visureFilters: visureFiltersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(websocketMiddleware),
});
